import api from '../../../api/client';
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Row, Col, Card, Alert, Spinner } from "react-bootstrap";

import config from "../../../config";
import Dashboard from "./Dashboard";
import Sales from "./Sales";
import Expenses from "./Expenses";
import Payroll from "./Payroll";
import ReceivablesDashboard from "./ReceivablesDashboard";
import PayablesDashboard from "./PayablesDashboard";
// import { Select } from "antd";
import Select from "react-select";

import { Tabs } from "antd";
import {
  DashboardOutlined,
  DollarOutlined,
  MoneyCollectOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  LineChartOutlined,
} from "@ant-design/icons";

export default function AccountantDashboard() {
  const [metrics, setMetrics] = useState(null);
  const [hrMetrics, setHrMetrics] = useState(null);
  const [payrollStatus, setPayrollStatus] = useState([]);
  const [recentPayments, setRecentPayments] = useState([]);
  const [upcomingPayments, setUpcomingPayments] = useState([]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [error, setError] = useState(null);
  const [fetchedTabs, setFetchedTabs] = useState({});
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  // format as YYYY-MM-DD
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [dateRange, setDateRange] = useState({
    startDate: formatDate(oneMonthAgo),
    endDate: formatDate(today),
    period: "30", // still keeping period in days
  });
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    axios
      .get(`/accountant/dashboard`)
      .then((res) => setMetrics(res.data));
    axios
      .get(`/payroll/status-summary`)
      .then((res) => setPayrollStatus(res.data));
    axios
      .get(`/recent-payments`)
      // .get(`/payments/recent?type=salary`)
      .then((res) => setRecentPayments(res.data));
    axios
      .get(`/payroll/upcoming`)
      .then((res) => setUpcomingPayments(res.data));
  }, []);

  const periodOptions = [
    { value: "7", label: "Last 7 Days" },
    { value: "30", label: "Last 30 Days" },
    { value: "90", label: "Last 90 Days" },
    { value: "365", label: "Last Year" },
    { value: "custom", label: "Custom Range" },
  ];
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  // console.log(metrics);

  const filteredUpcoming = filterStatus
    ? upcomingPayments.filter((p) => p.status === filterStatus.value)
    : upcomingPayments;

  const upcomingColumns = [
    { name: "Employee", selector: (row) => row.employee_name, sortable: true },
    { name: "Period", selector: (row) => row.period, sortable: true },
    {
      name: "Net Amount",
      selector: (row) => `Ksh ${row.net?.toLocaleString()}`,
      sortable: true,
    },
    {
      name: "Due Date",
      selector: (row) => new Date(row.dueDate).toLocaleDateString(),
      sortable: true,
    },
  ];

  useEffect(() => {
    setLoading(true);
    const fetchUserRoles = async () => {
      try {
        const response = await api.get(`/hr/dashboard`);
        const data = response.data;
        setHrMetrics(data);
      } catch (error) {
} finally {
        setLoading(false); // ✅ Done loading whether success or error
      }
    };

    fetchUserRoles();
  }, []);

  const handleDateRangeChange = (newDateRange) => {
    setDateRange(newDateRange);
  };

  const cache = useRef({});

  const fetchData = async (endpoint, setData) => {
    const key = `${endpoint}-${dateRange.startDate}-${dateRange.endDate}-${dateRange.period}`;
    if (cache.current[key]) {
      setData(cache.current[key]); // use cached data
      return;
    }

    try {
      const params = new URLSearchParams();
      if (dateRange.startDate && dateRange.endDate) {
        params.append("startDate", dateRange.startDate);
        params.append("endDate", dateRange.endDate);
      } else {
        params.append("period", dateRange.period);
      }

      const response = await fetch(`/api/${endpoint}?${params}`);
      const data = await response.json();
      cache.current[key] = data; // cache it
      setData(data);
    } catch (err) {
      console.error(err);
    }
  };

  // Custom styles for tabs
  const tabStyle = {
    marginBottom: 24,
    borderRadius: 8,
    overflow: "hidden",
  };

  const tabBarStyle = {
    background: "#f5f5f5",
    padding: "0 16px",
    margin: 0,
  };

  return (
    <>
      <div className="mb-4">
        <select
          value={dateRange.period}
          onChange={(e) =>
            setDateRange({
              ...dateRange,
              period: e.target.value,
              ...(e.target.value !== "custom"
                ? {
                    startDate: formatDate(
                      new Date(
                        today.setDate(
                          today.getDate() - parseInt(e.target.value),
                        ),
                      ),
                    ),
                    endDate: formatDate(new Date()),
                  }
                : {}),
            })
          }
          className="form-select form-select-sm me-2 mb-2 mb-md-0"
          style={{ width: "auto" }}
        >
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="90">Last 90 Days</option>
          <option value="365">Last Year</option>
          <option value="custom">Custom Range</option>
        </select>
        {/* <Select
            options={periodOptions}
            value={periodOptions.find((opt) => opt.value === dateRange.period)}
            onChange={(selectedOption) => {
              const today = new Date();
              setDateRange({
                ...dateRange,
                period: selectedOption.value,
                ...(selectedOption.value !== "custom"
                  ? {
                      startDate: formatDate(
                        new Date(
                          today.setDate(
                            today.getDate() - parseInt(selectedOption.value),
                          ),
                        ),
                      ),
                      endDate: formatDate(new Date()),
                    }
                  : {}),
              });
            }}
            className="me-2 mb-2 mb-md-0"
            styles={{
              container: (provided) => ({
                ...provided,
                width: "auto",
                minWidth: 180, // adjust width as needed
              }),
            }}
          /> */}

        {dateRange.period === "custom" && (
          <div className="d-flex align-items-center me-2 mb-2 mb-md-0">
            <input
              type="date"
              value={dateRange.startDate}
              onChange={(e) =>
                setDateRange({
                  ...dateRange,
                  startDate: e.target.value,
                })
              }
              className="form-control form-control-sm me-1"
              style={{ width: "130px" }}
            />
            <span className="me-1">to</span>
            <input
              type="date"
              value={dateRange.endDate}
              onChange={(e) =>
                setDateRange({
                  ...dateRange,
                  endDate: e.target.value,
                })
              }
              className="form-control form-control-sm"
              style={{ width: "130px" }}
            />
          </div>
        )}
        {/* <button className="btn btn-light btn-sm">
            <i className="fas fa-download me-1"></i> Export
          </button> */}
      </div>

      {error && (
        <Alert variant="danger" className="mb-3">
          <Alert.Heading>Error</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}

      {loading && (
        <div className="text-center mb-3">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading data...</p>
        </div>
      )}

      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        type="line"
        size="large"
        style={tabStyle}
        tabBarStyle={tabBarStyle}
        items={[
          {
            key: "dashboard",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DashboardOutlined />
                Dashboard
              </span>
            ),
            children: (
              <Dashboard
                dateRange={dateRange}
                fetchData={fetchData}
                recentPayments={recentPayments}
              />
            ),
          },
          {
            key: "sales",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DollarOutlined />
                Sales
              </span>
            ),
            children: <Sales dateRange={dateRange} fetchData={fetchData} />,
          },
          {
            key: "expenses",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <MoneyCollectOutlined />
                Expenses
              </span>
            ),
            children: <Expenses dateRange={dateRange} fetchData={fetchData} />,
          },
          {
            key: "receivables",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FileTextOutlined />
                Receivables
              </span>
            ),
            children: (
              <ReceivablesDashboard
                dateRange={dateRange}
                fetchData={fetchData}
              />
            ),
          },
          {
            key: "payables",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FileDoneOutlined />
                Payables
              </span>
            ),
            children: (
              <PayablesDashboard dateRange={dateRange} fetchData={fetchData} />
            ),
          },
          {
            key: "payroll",
            label: (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <LineChartOutlined />
                Payroll
              </span>
            ),
            children: (
              <Payroll
                upcomingPayments={upcomingPayments}
                recentPayments={recentPayments}
                payrollStatus={payrollStatus}
                upcomingColumns={upcomingColumns}
                filteredUpcoming={filteredUpcoming}
                metrics={metrics}
                hrMetrics={hrMetrics}
              />
            ),
          },
        ]}
      />
    </>
  );
}
